import { createStyles, rem } from "@mantine/core"

export const useStyles = createStyles(() => ({
    input: {
        maxWidth: rem(300),
        width: "auto",

        "& .mantine-Input-input": {
            borderWidth: 1,
            borderColor: "transparent",
            outlineWidth: 0,
            cursor: "pointer",
            backgroundColor: "transparent",
            padding: 0,
            paddingLeft: rem(6),

            "&:focus": {
                boxShadow: "none",
                borderColor: "#3E2AA3",
            },

            "&:hover:not(:focus)": {
                borderColor: "#CED4DA",
            },
        },
    },
}))
